import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import AppButton from '../../../components/designe/app-button/AppButton';
import ConfirmDialog from '../../../components/reusable/confirm-dialog/ConfirmDialog';
import { useStyles } from './AppVariables.styles';
import theme from '../../../styles/theme';
import { useAccess } from '../../../hooks/useAccess';
import { useAppVariablesComponent } from './useAppVariablesComponent';
import Search from '../../../components/reusable/search/Search';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import AddAppVariable from './add-app-variable/AddAppVariable';
import { AppVariablesFilter } from './AppVariablesFilter';

function AppVariables() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    itemForDelete,
    setItemForDelete,
    onItemDelete,
    filter,
    setFilter,
    showEditModal,
    setShowEditModal,
    itemForEditing,
    setItemForEditing,
    filterFormik,
    filterTypeOptions,
    filterIsPrivateOptions,
  } = useAppVariablesComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <AppVariablesFilter
        formik={filterFormik}
        filterTypeOptions={filterTypeOptions}
        filterIsPrivateOptions={filterIsPrivateOptions}
      />
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
        {access?.appVariables?.canCreate && (
          <AppButton onClick={() => setShowEditModal(true)}>
            {t('common.add')}
          </AppButton>
        )}
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
      <ConfirmDialog
        open={!!itemForDelete}
        onClose={() => setItemForDelete(null)}
        title={t('common.delete')}
        onSubmit={() => onItemDelete()}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>

      <AppDialog
        open={!!showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setItemForEditing(null);
        }}
        title={
          itemForEditing
            ? t('adminDashboard.editAppVariable')
            : t('adminDashboard.addAppVariable')
        }>
        <AddAppVariable
          appVariable={itemForEditing}
          onClose={() => {
            setShowEditModal(false);
            setItemForEditing(null);
          }}
        />
      </AppDialog>
    </div>
  );
}

export default AppVariables;
